module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "vw-password",
    on: {
      "click": _vm.onFocus
    }
  }, [_c('div', {
    staticClass: "vw-password-wrapper"
  }, _vm._l((_vm.len), function(i) {
    return _c('div', {
      staticClass: "vw-password-wrapper-item",
      class: {
        'content': _vm.password.length > i - 1
      }
    })
  })), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "vw-password-input",
    attrs: {
      "type": "password",
      "autofocus": _vm.autofocus
    },
    domProps: {
      "value": _vm._s(_vm.password)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }, _vm.onInput]
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.2@vue-loader/lib/template-compiler.js?id=data-v-a7f939b8!./~/.10.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/password/password.vue
// module id = 280
// module chunks = 0